import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Image, InputGroup, Badge, Dropdown, Card, Table } from 'react-bootstrap';
import {
    FaSearch,
    FaPhone,
    FaVideo,
    FaUsers,
    FaUserFriends,
    FaEllipsisH,
    FaSmile,
    FaPaperclip,
    FaPaperPlane,
    FaDownload,
    FaEllipsisV,
    FaUser,
    FaThumbsUp,
    FaComment,
    FaAddressBook,
    FaCog,
    FaGlobe,
    FaMoon,
    FaBars,
    FaTimes,
    FaCalendarAlt,
    FaFilter,
    FaChevronLeft,
    FaChevronRight,
    FaHistory,
    FaArrowLeft,
    FaTrash,
    FaStar,
    FaArchive,
    FaTag,
    FaExclamationCircle,
    FaCheck,
    FaArrowRight,
    FaEllipsisV as FaMore,
    FaReply,
    FaExternalLinkAlt,
    FaPlus,
    FaSortDown,
    FaEllipsisV as FaEllipsisVertical,
    FaCheckCircle
} from 'react-icons/fa';
import GlobalMiniSidebar from './GlobalMiniSidebar';
import './UsersPage.css';

const UsersPage = () => {
    const [activeContact, setActiveContact] = useState('Patrick Hendricks');
    const [showSidebar, setShowSidebar] = useState(false);
    const [filterDate, setFilterDate] = useState('All time');
    const [currentDateRange, setCurrentDateRange] = useState('March 2025');
    const sidebarRef = useRef(null);
    const historyContainerRef = useRef(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    // Sample users data
    const users = [
        {
            id: 1,
            name: "Florence Shaw",
            email: "florence@untitledu.com",
            access: "Admin",
            lastActive: "Mar 4, 2024",
            dateAdded: "July 4, 2022",
            avatar: "/assets/avatars/user-1.png",
            dataExport: true,
            dataImport: true
        },
        {
            id: 2,
            name: "Amélie Laurent",
            email: "amelie@untitledu.com",
            access: "Admin",
            lastActive: "Mar 4, 2024",
            dateAdded: "July 4, 2022",
            avatar: "/assets/avatars/user-2.png",
            dataExport: true,
            dataImport: true
        },
        {
            id: 3,
            name: "Ammar Foley",
            email: "ammar@untitledu.com",
            access: "",
            lastActive: "Mar 2, 2024",
            dateAdded: "July 4, 2022",
            avatar: "/assets/avatars/user-3.png",
            dataExport: true,
            dataImport: true
        },
        {
            id: 4,
            name: "Caitlyn King",
            email: "caitlyn@untitledu.com",
            access: "",
            lastActive: "Mar 6, 2024",
            dateAdded: "July 4, 2022",
            avatar: "/assets/avatars/user-4.png",
            dataExport: true,
            dataImport: true
        },
        {
            id: 5,
            name: "Sienna Hewitt",
            email: "sienna@untitledu.com",
            access: "",
            lastActive: "Mar 8, 2024",
            dateAdded: "July 4, 2022",
            avatar: "/assets/avatars/user-5.png",
            dataExport: true,
            dataImport: true
        },
        {
            id: 6,
            name: "Olly Shroeder",
            email: "olly@untitledu.com",
            access: "",
            lastActive: "Mar 6, 2024",
            dateAdded: "July 4, 2022",
            avatar: "/assets/avatars/user-6.png",
            dataExport: true,
            dataImport: true
        },
        {
            id: 7,
            name: "Mathilde Lewis",
            email: "mathilde@untitledu.com",
            access: "",
            lastActive: "Mar 4, 2024",
            dateAdded: "July 4, 2022",
            avatar: "/assets/avatars/user-7.png",
            dataExport: true,
            dataImport: true
        },
        {
            id: 8,
            name: "Jaya Willis",
            email: "jaya@untitledu.com",
            access: "",
            lastActive: "Mar 4, 2024",
            dateAdded: "July 4, 2022",
            avatar: "/assets/avatars/user-8.png",
            dataExport: true,
            dataImport: true
        }
    ];

    // Toggle sidebar for mobile view
    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    // Handle select all users
    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedUsers([]);
        } else {
            setSelectedUsers(users.map(user => user.id));
        }
        setSelectAll(!selectAll);
    };

    // Handle single user selection
    const handleUserSelect = (userId) => {
        if (selectedUsers.includes(userId)) {
            setSelectedUsers(selectedUsers.filter(id => id !== userId));
        } else {
            setSelectedUsers([...selectedUsers, userId]);
        }
    };

    // Handle search input change
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    // Filter users based on search query
    const filteredUsers = users.filter(user => {
        const searchTerm = searchQuery.toLowerCase();
        return (
            user.name.toLowerCase().includes(searchTerm) ||
            user.email.toLowerCase().includes(searchTerm) ||
            user.access.toLowerCase().includes(searchTerm) ||
            user.lastActive.toLowerCase().includes(searchTerm) ||
            user.dateAdded.toLowerCase().includes(searchTerm)
        );
    });

    // Show success toast for user update
    const showUpdateSuccess = (name) => {
        setSuccessMessage(`"${name}" details updated`);
        setShowSuccessToast(true);

        // Hide toast after 3 seconds
        setTimeout(() => {
            setShowSuccessToast(false);
        }, 3000);
    };

    // Pagination settings
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(filteredUsers.length / 8);

    // Get paginated users
    const getCurrentPageUsers = () => {
        const startIndex = (currentPage - 1) * 8;
        const endIndex = startIndex + 8;
        return filteredUsers.slice(startIndex, endIndex);
    };

    useEffect(() => {
        // Simulate an update success message after component mounts
        setTimeout(() => {
            showUpdateSuccess("Amélie Laurent");
        }, 1000);
    }, []);

    return (
        <Container fluid className="chat-container p-0">
            <div className="d-flex chat-wrapper">
                <GlobalMiniSidebar />

                {/* Main Content Area */}
                <div className="chat-main-container">
                    {/* User Management Content */}
                    <div className="user-management-container p-4">
                        {/* Header Section */}
                        <div className="header-section mb-4">
                            <h1 className="mb-1 fw-bold">User management</h1>
                            <p className="text-muted">Manage your team members and their account permissions here.</p>
                        </div>

                        {/* User List Panel */}
                        <div className="user-list-panel bg-white rounded shadow-sm mb-4">
                            {/* Panel Header */}
                            <div className="panel-header d-flex justify-content-between align-items-center p-3 border-bottom">
                                <div className="d-flex align-items-center">
                                    <h5 className="mb-0 me-2">All users</h5>
                                    <Badge bg="light" text="dark" className="rounded-pill">44</Badge>
                                </div>
                                <div className="d-flex">
                                    {/* Search Input */}
                                    <div className="search-container me-2">
                                        <InputGroup>
                                            <InputGroup.Text className="bg-white">
                                                <FaSearch className="text-muted" />
                                            </InputGroup.Text>
                                            <Form.Control
                                                placeholder="Search"
                                                value={searchQuery}
                                                onChange={handleSearchChange}
                                                className="border-start-0"
                                            />
                                        </InputGroup>
                                    </div>

                                    {/* Filters Button */}
                                    <Button variant="light" className="d-flex align-items-center me-2">
                                        <span>Filters</span>
                                    </Button>

                                    {/* Add User Button */}
                                    <Button variant="dark" className="d-flex align-items-center">
                                        <FaPlus className="me-1" />
                                        <span>Add user</span>
                                    </Button>
                                </div>
                            </div>

                            {/* Users Table */}
                            {/* <div className="users-table">
                                <Table hover className="mb-0">
                                    <thead>
                                        <tr className="bg-light">
                                            <th width="40">
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                />
                                            </th>
                                            <th>User name</th>
                                            <th>Access</th>
                                            <th className="d-flex align-items-center">
                                                Last active <FaSortDown className="ms-1" />
                                            </th>
                                            <th>Date added</th>
                                            <th width="40"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        [ Scroll ]
                                        {getCurrentPageUsers().map(user => (
                                            <tr key={user.id}>
                                                <td>
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={selectedUsers.includes(user.id)}
                                                        onChange={() => handleUserSelect(user.id)}
                                                    />
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <Image
                                                            src={user.avatar}
                                                            alt={user.name}
                                                            roundedCircle
                                                            width={32}
                                                            height={32}
                                                            className="me-2"
                                                        />
                                                        <div>
                                                            <div className="fw-bold">{user.name}</div>
                                                            <div className="text-muted small">{user.email}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {user.access ? (
                                                        <Badge bg="success" className="rounded-pill py-1 px-2 fw-normal">{user.access}</Badge>
                                                    ) : null}
                                                    
                                                    {user.dataExport && (
                                                        <Badge bg="light" text="primary" className="rounded-pill py-1 px-2 fw-normal ms-1">Data Export</Badge>
                                                    )}
                                                    
                                                    {user.dataImport && (
                                                        <Badge bg="light" text="primary" className="rounded-pill py-1 px-2 fw-normal ms-1">Data Import</Badge>
                                                    )}
                                                </td>
                                                <td>{user.lastActive}</td>
                                                <td>{user.dateAdded}</td>
                                                <td className="text-center">
                                                    <Button variant="link" className="p-0 text-muted">
                                                        <FaEllipsisVertical />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div> */}

                            <div className="users-table-container">
                                <Table hover className="mb-0">
                                    <thead>
                                        <tr className="bg-light">
                                            <th width="40">
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                />
                                            </th>
                                            <th>User name</th>
                                            <th>Access</th>
                                            <th className="d-flex align-items-center">
                                                Last active <FaSortDown className="ms-1" />
                                            </th>
                                            <th>Date added</th>
                                            <th width="40"></th>
                                        </tr>
                                    </thead>
                                </Table>
                                <div className="table-scroll-container">
                                    <Table hover className="mb-0">
                                        <tbody>
                                            {getCurrentPageUsers().map(user => (
                                                <tr key={user.id}>
                                                    <td width="40">
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={selectedUsers.includes(user.id)}
                                                            onChange={() => handleUserSelect(user.id)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <Image
                                                                src={user.avatar}
                                                                alt={user.name}
                                                                roundedCircle
                                                                width={32}
                                                                height={32}
                                                                className="me-2"
                                                            />
                                                            <div>
                                                                <div className="fw-bold">{user.name}</div>
                                                                <div className="text-muted small">{user.email}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {user.access ? (
                                                            <Badge bg="success" className="rounded-pill py-1 px-2 fw-normal">{user.access}</Badge>
                                                        ) : null}

                                                        {user.dataExport && (
                                                            <Badge bg="light" text="primary" className="rounded-pill py-1 px-2 fw-normal ms-1">Data Export</Badge>
                                                        )}

                                                        {user.dataImport && (
                                                            <Badge bg="light" text="primary" className="rounded-pill py-1 px-2 fw-normal ms-1">Data Import</Badge>
                                                        )}
                                                    </td>
                                                    <td>{user.lastActive}</td>
                                                    <td>{user.dateAdded}</td>
                                                    <td className="text-center" width="40">
                                                        <Button variant="link" className="p-0 text-muted">
                                                            <FaEllipsisVertical />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>

                            {/* Pagination */}
                            <div className="pagination-container d-flex justify-content-center p-3 border-top">
                                <ul className="pagination mb-0">
                                    <li className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(1)}>1</button>
                                    </li>
                                    {Array.from({ length: Math.min(totalPages - 1, 5) }, (_, i) => (
                                        <li key={i + 2} className={`page-item ${currentPage === i + 2 ? 'active' : ''}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(i + 2)}>{i + 2}</button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Success Toast Notification */}
                        {showSuccessToast && (
                            <div className="toast-container position-fixed bottom-0 end-0 p-3">
                                <div className="toast show bg-dark text-white" role="alert" aria-live="assertive" aria-atomic="true">
                                    <div className="toast-body d-flex align-items-center">
                                        <FaCheckCircle className="text-success me-2" />
                                        <span>{successMessage}</span>
                                        <button type="button" className="btn-close btn-close-white ms-auto" onClick={() => setShowSuccessToast(false)}></button>
                                    </div>
                                    <div className="toast-actions border-top border-secondary py-2 px-3 d-flex">
                                        <Button variant="link" className="text-white text-decoration-none p-0 me-3">
                                            Undo
                                        </Button>
                                        <Button variant="link" className="text-white text-decoration-none p-0">
                                            View profile
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default UsersPage;